
import React from "react";
import { cn } from "@/lib/utils";

export interface BrandGradientProps {
  variant?: "primary" | "purple" | "blue" | "indigo";
  intensity?: "light" | "medium" | "strong";
  children?: React.ReactNode;
  className?: string;
}

/**
 * Gradient background component that follows the VirtuStaff brand guidelines
 */
export const BrandGradient: React.FC<BrandGradientProps> = ({
  variant = "primary",
  intensity = "medium",
  children,
  className,
}) => {
  const variantStyles = {
    primary: {
      light: "bg-gradient-to-r from-primary-100 to-secondary-100",
      medium: "bg-gradient-to-r from-primary-300 to-secondary-300",
      strong: "bg-gradient-to-r from-primary-500 to-secondary-500",
    },
    purple: {
      light: "bg-gradient-to-r from-purple-100 to-pink-100",
      medium: "bg-gradient-to-r from-purple-300 to-pink-300",
      strong: "bg-gradient-to-r from-purple-500 to-pink-500",
    },
    blue: {
      light: "bg-gradient-to-r from-blue-100 to-cyan-100",
      medium: "bg-gradient-to-r from-blue-300 to-cyan-300",
      strong: "bg-gradient-to-r from-blue-500 to-cyan-500",
    },
    indigo: {
      light: "bg-gradient-to-r from-indigo-100 to-blue-100",
      medium: "bg-gradient-to-r from-indigo-300 to-blue-300",
      strong: "bg-gradient-to-r from-indigo-500 to-blue-500",
    },
  };

  const gradientStyle = variantStyles[variant][intensity];

  return (
    <div className={cn(gradientStyle, "bg-opacity-20", className)}>
      {children}
    </div>
  );
};
